import React, { useState, useEffect, useRef } from 'react';
import { Button, Modal, Form, Input, Spin, Select, Row, Col, DatePicker, Space } from 'antd';
import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';
import { Config } from '../../public/js/config';
import { Base } from '../../public/js/base';
import PropTypes from 'prop-types';//props传参检查库
import Message from '../../component/message/message';
import context from '../../public/js/context';
import trans from './translation';
import './industrialPartner.css'
import moment from 'moment';//日期格式化导包

const { Option } = Select;

const RoleFromModal = (props) => {
    const [isDisabled, setIsDisabled] = useState(true);
    const messageRef = useRef();
    const [form] = Form.useForm();
    const [isLoad, setIsLoad] = useState(false);
    const partnerModel = props.partnerModel;
    const [partnerContractModel, setPartnerContractModel] = useState(props.partnerContractModel);
    const [deptModel, setDeptModel] = useState([]);
    const [flag, setFlag] = useState(props.partnerContractFormFlag);
    const [spinInfo, setSpinInfo] = useState("");
    const [defaultDate, setDefaultDate] = useState(moment());

    useEffect(() => {
        
        initForm(partnerContractModel)
        if(!partnerContractModel.activeInd){
            initForm({ activeInd: 'Y' });
        }
        searchDept();
    }, []);

    const searchDept  =()  =>{
        Base.callBackApi('commonDropDown/searchAllDept').then((data) => {
            if ("SUCCESS" == data.msg) {
                setDeptModel(data?.object?? []); 
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => {
            setIsLoad(false)
        });
    }

    const initForm = (model) => {
        form.setFieldsValue({
            partnerId: model.partnerId ?? "",
            userId: model.userId ?? "",
            partnerContactAcctId: model.partnerContactAcctId ?? "",
            contactName: model.contactName ?? "",
            contactTitle: model.contactTitle ?? "",
            contactJobTitle: model.contactJobTitle ?? "",
            contactDept: model.contactDept ?? "",
            contactEmail: model.contactEmail ?? "",
            contactOfficePhone: model.contactOfficePhone ?? "",
            contactMobilePhone: model.contactMobilePhone ?? "",
            activeInd: model.activeInd ?? "",
            inactiveDate: model.inactiveDate ? moment( moment(model.inactiveDate).format(Config.dateFormat5),Config.dateFormat5):null,
        });
    }

    const save = () => {
        form.submit();
    }

    const onFinish = (model) => {
        messageShowHandler();//清空提示信息
        if(isLoad) {
            return
        }
        setIsLoad(true);
        setSpinInfo(trans.dataBeSaving[Config.backLang])
        model.partnerId = partnerModel.partnerId;
        model.theiDeptId = partnerModel.theiDeptId;
        model.theiContactName = partnerModel.theiContactName;
        let url = "";
        if (flag === "add") {
            url = "partnerContact/insert";
        } else if (flag === "edit") {
            url = "partnerContact/update";
            model.partnerContactId = partnerContractModel.partnerContactId;
            model.partnerId = partnerContractModel.partnerId;
            model.userId = partnerContractModel.userId;
            model.lastUpdatedDate = partnerContractModel.lastUpdatedDate;
        }
        model.menuFuncId = Config.funcInfo.funcId;
        Base.callBackApi(url, model).then((data) => {
            if ("SUCCESS" == data.msg) {
                errFrameShow("success", trans.saveSuccess[Config.backLang]);
                onCancel(true)
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => {
            setIsLoad(false)
        });
    }

    const onCancel = (flag = false) => {
        props.onClose(flag);
    }

    const errFrameShow = (style, msg) => {
        messageRef.current.setStyle(style)
        messageRef.current.setContent(msg)
        messageRef.current.setIsShow(true)
        document.documentElement.scrollTop = 0;
    }

    const messageShowHandler = () => {
        messageRef.current.setIsShow(false)
    }

    const disabledDate = current => {
        return current && current > moment().endOf('day');
    };

    const handleChange = (value) => {
        if(value ==='N'){
            form.setFieldValue('inactiveDate',moment());
            setIsDisabled(false)
        }else{
            form.setFieldValue('inactiveDate',null);
            setIsDisabled(true)
        }
    }

    return (
        <Spin size="large" spinning={isLoad} tip={trans.dataBeSaving[Config.backLang]}>
            <Modal
                className='studentProgFormModal'
                visible={true}//控制弹框是否显示
                title={trans.partnerContactFormModalTitle[Config.backLang]}//标题
                centered//垂直居中
                destroyOnClose={true}//关闭即销毁？
                closable//是否显示右上角的关闭按钮
                maskClosable={false}//点击蒙层是否允许关闭	
                // width={Config.equipmentInfo.type === 'iPad' ? '65%' : (Config.equipmentInfo.type === 'phone' ? '100%' : '50%')}//弹框宽度
                width={'1000px'}
                onCancel={() => onCancel(false)}//点击取消触发事件
                footer={[
                    <Button key='save' className="sysBtn btnBlue" type="primary" onClick={save} icon={<CheckCircleOutlined />}>{trans.save[Config.backLang]}</Button>,
                    <Button key='cancel' className="sysBtn" onClick={() => onCancel(false)} icon={<CloseCircleOutlined />}>{trans.cancel[Config.backLang]}</Button>
                ]}
            >
                <Message ref={messageRef} />
                <Form form={form} onFinish={onFinish}>
                    <div className='sysRow'>
                        <div className='sysCol'>
                            <div className="sysParam mustFill">{trans.contactID[Config.backLang]}</div>
                            <div className="sysInput">
                                <Form.Item
                                    name="partnerContactAcctId"
                                    rules={[
                                        { required: true, message: "Industry Partner ID is required." },
                                    ]}
                                >
                                    <Input type="text" placeholder={trans.contactID[Config.backLang]} maxLength={50}  disabled={flag === 'edit'} />
                                </Form.Item>
                            </div>
                        </div>

                        <div className='sysCol'>
                            <div className="sysParam mustFill">{trans.industrialPartnerContactName[Config.backLang]}</div>
                            <div className="sysInput">
                                <Form.Item
                                    name="contactName"
                                    rules={[
                                        { required: true, message: "Name is required." },
                                    ]}
                                >
                                    <Input type="text" placeholder={trans.industrialPartnerContactName[Config.backLang]} maxLength={50} />
                                </Form.Item>
                            </div>
                        </div>
                    </div>
                    <div className='sysRow'>
                        <div className='sysCol'>
                            <div className="sysParam ">{trans.contactTitle[Config.backLang]}</div>
                            <div className="sysInput">
                                <Form.Item
                                    name="contactTitle"
                                    rules={[
                                        
                                    ]}
                                >
                                    <Input type="text" placeholder={trans.contactTitle[Config.backLang]} maxLength={80} />
                                </Form.Item>
                            </div>
                        </div>
                        

                        <div className='sysCol'>
                            <div className="sysParam ">{trans.contactPersonJobTitle[Config.backLang]}</div>
                            <div className="sysInput">
                                <Form.Item
                                    name="contactJobTitle"
                                    rules={[
                                       
                                    ]}
                                >
                                    <Input type="text" placeholder={trans.contactPersonJobTitle[Config.backLang]} maxLength={50} />
                                </Form.Item>
                            </div>
                        </div>
                    </div>

                    <div className='sysRow'>
                        <div className='sysCol'>
                            <div className="sysParam ">Department</div>
                            <div className="sysInput">
                                <Form.Item
                                    name="contactDept"
                                    rules={[
                                         
                                    ]}
                                >
                                    <Input type="text" placeholder="Department" maxLength={40} />
                                </Form.Item>
                            </div>
                        </div>

                        <div className='sysCol'>
                            <div className="sysParam mustFill">Email</div>
                            <div className="sysInput">
                                <Form.Item
                                    name="contactEmail"
                                    rules={[
                                        { required: true, message: "Email is required." },
                                        { pattern: /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,4}$/, message: "Incorrect Email format." },
                                    ]}
                                >
                                    <Input type="text" placeholder="Email" maxLength={200} />
                                </Form.Item>
                            </div>
                        </div>
                    </div>

                    <div className='sysRow'>
                        <div className='sysCol'>
                            <div className="sysParam ">Office Phone</div>
                            <div className="sysInput">
                                <Form.Item
                                    name="contactOfficePhone"
                                    rules={[
                                        
                                    ]}
                                >
                                    <Input type="text" placeholder="Office Phone" maxLength={12} />
                                </Form.Item>
                            </div>
                        </div>

                        <div className='sysCol'>
                            <div className="sysParam ">Mobile</div>
                            <div className="sysInput">
                                <Form.Item
                                    name="contactMobilePhone"
                                    rules={[
                                        
                                    ]}
                                >
                                    <Input type="text" placeholder="Mobile" maxLength={12} />
                                </Form.Item>
                            </div>
                        </div>
                    </div>
                    <div className='sysRow'>
                        <div className='sysCol'>
                            <div className="sysParam mustFill">Status</div>
                            <div className="sysInput">
                                <Form.Item
                                    name="activeInd"
                                >
                                    <Select className='sysSelect' onChange={handleChange}>
                                        <Option value=''></Option>
                                        {context.activeStatusMap.map((item) => <Option key={item.value} value={item.value}>{item.label}</Option>)}
                                    </Select>
                                </Form.Item>
                            </div>
                        </div>

                        {isDisabled ?
                            <div className='sysCol'>
                                <div className="sysParam sysParamInput">Inactive Date</div>
                                <div className="sysInput">
                                    <Form.Item
                                        name="inactiveDate"
                                    >
                                        <DatePicker placeholder="Inactive Date" disabled />
                                    </Form.Item>
                                </div>
                            </div> : <div className='sysCol'>
                                <div className="sysParam sysParamInput mustFill">Inactive Date</div>
                                <div className="sysInput">
                                    <Form.Item
                                        name="inactiveDate"
                                        rules={[
                                            { required: true, message: "Inactive Date is required." },
                                        ]}
                                    >

                                        <DatePicker placeholder="Inactive Date" 
                                        value={defaultDate}
                                        disabledDate={disabledDate}
                                        />
                                    </Form.Item>
                                </div>
                            </div>
                        }
                    </div>

                </Form>
            </Modal>
        </Spin>
    )

}

RoleFromModal.propTypes = {
    onClose: PropTypes.func.isRequired,
    partnerModel: PropTypes.object.isRequired,
    partnerContractModel: PropTypes.object.isRequired,
    partnerContractFormFlag: PropTypes.string.isRequired,
    deptModel: PropTypes.object.isRequired,
}

export default RoleFromModal;